export const QUERY_KEY = {
  CurrentUser: 'currentUser',
  CustomerInfo: 'customerInfo',
  EnterpriseInfo: 'enterpriseInfo',
  HotWords: 'hotWords',
  getBanners: 'getBanners',
  getLayoutImages: 'getLayoutImages',
  getCategoryFirstItem: 'getCategoryFirstItem',
  getSupplierRecommend: 'getSupplierRecommend',
  getHotAddress: 'getHotAddress',
  getAreas: 'getAreas',
  getCategories: 'getCategories',
  getRecommendSuppliers: 'getRecommendSuppliers',
  getSupplierData: 'getSupplierData',
  getSupplierDetail: 'getSupplierDetail',
  getCompanyDesc: 'getCompanyDesc',
  getFrontDeskCategoryList: 'getFrontDeskCategoryList',
  getSupplierProductPage: 'getSupplierProductPage',
  getHalls: 'getHalls',
  validateOffer: 'validateOffer',
  queryKeywords: 'queryKeywords',
  queryKeywordsAi: 'queryKeywordsAi',
  getCityAreas: 'getCityAreas',
  getCityAreasSort: 'getCityAreasSort',
  getCategoryItemByBusiness: 'getCategoryItemByBusiness',
  MemberQuotaBase: 'memberQuotaBase',
}
